export const FLAG_4X3_BASE_PATH =
  'https://unpkg.com/@razorpay/i18nify-js/lib/assets/flags';
export const FLAG_BASE_PATH = 'https://flagcdn.com';

export const I18NIFY_DATA_SOURCE =
  'https://raw.githubusercontent.com/razorpay/i18nify/master/i18nify-data';

export const I18NIFY_DATA_SUPPORTED_COUNTRIES = ['IN', 'MY', 'SG', 'US'];
